var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dolars"},[_c('div',[_c('h6',[_vm._v(_vm._s(_vm.code))]),_c('h5',[_vm._v(_vm._s(_vm.dolar))])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img"},[_c('img',{staticClass:"imgtemp",attrs:{"src":require("../../public/bolsavalor.png")}})])
}]

export { render, staticRenderFns }